import './instrument'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MotionConfig } from 'framer-motion'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import './styles/tailwind.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>} showDialog>
      <BrowserRouter>
        <MotionConfig transition={{ duration: 0.2, ease: [0.25, 0.1, 0.25, 1] }}>
          <App />
        </MotionConfig>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
